import React, { useEffect, useState } from 'react'
import {
  Backdrop,
  Fade,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import ButtonComponent from '../ButtonComponent'

import { useStyles } from './styles'

const LanguagesModal = ({
  cancel,
  isOpen,
  languages,
  selectedLang,
  setClose,
}) => {
  const classes = useStyles()
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(selectedLang)
  }, [isOpen])

  const handleChange = (event) => {
    setValue(event.target.value)
  }

  const handleClose = () => {
    setClose(value)
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <Grid className={classes.paper}>
          <Grid className={classes.header}>
            <Typography className={classes.title}>
              LANGUAGE SELECTION
            </Typography>
            <IconButton className={classes.closeButton} onClick={cancel}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </Grid>
          <Grid className={classes.content}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="language"
                name="language"
                value={value}
                defaultValue={selectedLang}
                onChange={handleChange}
              >
                {languages.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    alt={item.name} 
                    value={item.code}
                    control={
                      <Radio
                        classes={{
                          root: classes.radio,
                          checked: classes.checked,
                        }}
                      />
                    }
                    label={item.name}
                    className="no_translate"
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
          <ButtonComponent width="100%"  height="70px" text="Change Language" type="orange" onClick={handleClose} variant="contained" />
        </Grid>
      </Fade>
    </Modal>
  )
}

export { LanguagesModal }
